(() => {
  const bound = new WeakSet();
  const prefix = 'ecoflusso:pending-lead:';
  const maximumAge = 30 * 60 * 1000;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const markers = () => document.querySelectorAll('[data-ecoflusso-lead-form]');
  const keyFor = (form) => prefix + window.location.pathname + ':' + form.id;

  function processResult(marker, form) {
    if (!window.Shopify?.customerPrivacy) return;
    const success = marker.dataset.formSuccess === 'true';
    const error = marker.dataset.formError === 'true';
    if (!success && !error) return;
    let submittedAt;
    try {
      submittedAt = Number(window.sessionStorage.getItem(keyFor(form)));
      window.sessionStorage.removeItem(keyFor(form));
    } catch {
      return;
    }
    const age = Date.now() - submittedAt;
    if (!success || error || !submittedAt || age < 0 || age > maximumAge || !allowed()) return;
    if (typeof window.Shopify?.analytics?.publish !== 'function') return;
    try {
      Promise.resolve(window.Shopify.analytics.publish('ecoflusso:lead_submitted', {
        form_type: marker.dataset.formType,
        page_path: window.location.pathname,
        locale: marker.dataset.formLocale,
      })).catch(() => {});
    } catch {}
  }

  function bindForms() {
    markers().forEach((marker) => {
      const form = marker.closest('form');
      if (!form?.id) return;
      if (!bound.has(form)) {
        bound.add(form);
        form.addEventListener('submit', () => {
          if (!allowed() || !form.checkValidity()) return;
          try {
            window.sessionStorage.setItem(keyFor(form), String(Date.now()));
          } catch {}
        });
      }
      processResult(marker, form);
    });
  }

  bindForms();
  document.addEventListener('shopify:section:load', bindForms);
  document.addEventListener('visitorConsentCollected', bindForms);
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) bindForms();
    });
  }
})();
